import React from 'react'

const PoliticaControlParental = () => {
    return (
        <>
            <div className='div-container-legal-text-padre'>
                <h3 className='btn-close-modal' style={{ marginBottom: "2rem", fontFamily: "Newton Howard", color: "#fff", textAlign: "center" }}>Control Parental</h3>
                <p>
                    INFERNAL PARADISE S.A.S es un sitio web solo para adultos, para utilizar nuestro sitio web o acceder a
                    cualquier servicio de compañía o sexual, el interesado debe haber alcanzado la mayoría de
                    edad en la jurisdicción de su país. No somos responsables por cualquier tergiversación con
                    respecto a la edad de la persona. Los usuarios deben estar al tanto de saber que por ende
                    tienen la responsabilidad de implementar en sus dispositivos protecciones de control parental
                    (hadware de PC, software o servicios de filtrado) así estará limitado el acceso a menores de
                    edad este material exclusivo para adultos.
                </p>
                <br />
                <p>
                    <font style={{ color: "#FF1A1A" }}>Filtros de contenido:</font> Programas diseñados para controlar qué se permite mostrar,
                    restringiendo el acceso a cierto tipo de materiales en la Web.
                </p>
                <br />
                <p>
                    <font style={{ color: "#FF1A1A" }}>Controles de uso:</font> Limita el uso de estos dispositivos, ya sea imponiendo límites de tiempo,
                    prohibiendo ciertos tipos de uso o bloqueando el acceso de ciertos usuarios. Requieren la
                    figura de un administrador los regule.
                </p>
                <br />
                <p>
                    <font style={{ color: "#FF1A1A" }}>Herramientas de gestión del uso:</font> Se trata de programas que se instalan para asegurarse de
                    qué tareas y procesos específicos se están ejecutando (similar a un administrador de tareas).
                    Pueden impedir y bloquear que software no deseado esté activo en el ordenador. Se puede
                    aplicar al sistema en general o a los navegadores y servicios online.
                </p>
                <br />
                <p>
                    <font style={{ color: "#FF1A1A" }}>Monitorización del sistema:</font> Permite hacer un seguimiento de la ubicación y la actividad
                    cuando se utilizan los dispositivos. Notifica cuándo y dónde se está utilizando cada dispositivo.
                </p>
                <br />
                <h4 className='btn-close-modal' style={{ marginBottom: "2rem", fontFamily: "Newton Howard", color: "#fff", fontSize: "20px" }}>Herramientas importantes
                    para proteger a los niños del contenido para adultos :</h4>
                <ul>
                    <li style={{ marginBottom: "10px" }}>El modo de búsqueda segura en los motores de búsqueda bloquea el contenido para adultos
                        en los resultados de búsqueda
                    </li>
                    <li style={{ marginBottom: "10px" }}>Google Safe Search se puede activar para: cuentas o navegadores personales, dispositivos
                        supervisados para niños y cuentas que usan la aplicación Family Link, dispositivos y redes del
                        lugar de trabajo o de la escuela. Le recomendamos que active SafeSearch en los dispositivos de
                        todos los menores a su cargo.
                    </li>
                    <li style={{ marginBottom: "10px" }}>Yahoo SafeSearch ayudará a bloquear contenido explícito en los resultados de búsqueda de
                        Yahoo.
                    </li>
                    <li style={{ marginBottom: "10px" }}>Microsoft SafeSearch hará lo mismo con esos resultados de búsqueda en Bing
                    </li>
                    <li style={{ marginBottom: "10px" }}>Yandex Family Search excluirá el contenido no deseado de los resultados de búsqueda en
                        Yandex
                    </li>
                </ul>
                <br />
                <p>
                    También recomendamos instalar, predeterminar o exigir motores de búsqueda específicos por
                    edad en los dispositivos de sus hijos. Están especialmente diseñados para ayudar a examinar el
                    contenido web, como palabras, imágenes y videos. Además, son muy fáciles de usar y mucho
                    más visuales. Estas diferencias ayudan a los niños a encontrar lo que buscan sin llegar a
                    páginas que puedan resultar inapropiadas: Kiddle, KidRex, WackySafe, Kido’z.
                </p>
                <br />
            </div>
        </>
    )
}

export default PoliticaControlParental